import { AccordionComponent } from './Accordion.types';
import { Box, Button, Flexbox, Icon, IconDirection } from '@hiiretail/synergy-ui';
import { AccordionBody, AccordionHeader, AccordionWrapper } from './Accordion.style';
import { useState } from 'react';

export const Accordion: AccordionComponent = ({
  isExpanded = false,
  children,
  title,
  subTitle,
  styles,
  bodyStyles = {
    marginTop: '24px',
  },
}) => {
  const [isOpen, setIsOpen] = useState(isExpanded);

  const toggleIsOpen = () => {
    setIsOpen((prevState) => !prevState);
  };

  return (
    <AccordionWrapper container direction="column" style={styles}>
      <Box px={4} py={4}>
        <AccordionHeader
          container
          alignItems="center"
          onClick={() => {
            toggleIsOpen();
          }}
        >
          <Flexbox item container style={{ width: '25%' }}>
            {title}
          </Flexbox>
          <Flexbox item container style={{ width: '65%' }} justifyContent="flex-end">
            {subTitle}
          </Flexbox>
          <Flexbox item container style={{ width: '10%' }} justifyContent="flex-end">
            <Button variant="icon">
              <>
                {isOpen ? (
                  <Icon.Chevron direction={IconDirection.Up} />
                ) : (
                  <Icon.Chevron direction={IconDirection.Down} />
                )}
              </>
            </Button>
          </Flexbox>
        </AccordionHeader>

        {isOpen && (
          <AccordionBody container style={bodyStyles}>
            {children}
          </AccordionBody>
        )}
      </Box>
    </AccordionWrapper>
  );
};
